export function formInvoiceInput() {
    document.addEventListener("DOMContentLoaded", () => {
        const inputs = document.querySelectorAll('.inputfile');

        jQuery('#invoice').unwrap();

        inputs.forEach(input => {
            const label = input.nextElementSibling;
            const labelVal = 'Wybierz';

            input.addEventListener('change', e => {
                let fileName = '';

                if (input.files && input.files.length > 1) {
                    fileName = (input.getAttribute('data-multiple-caption') || '').replace('{count}', input.files.length);
                } else {
                    fileName = e.target.value.split('\\').pop();
                }

                if (fileName) {
                    label.querySelector('span').innerHTML = fileName;
                } else {
                    label.innerHTML = labelVal;
                }
            });

            input.addEventListener('focus', () => input.classList.add('has-focus'));
            input.addEventListener('blur', () => input.classList.remove('has-focus'));
        });
    });
}
